import type { CandidateStage } from '../../types';

/** Stages of candidates still in a JD's pipeline; Rejected and Talent Pool are not active. */
export const ACTIVE_CANDIDATE_STAGES: CandidateStage[] = [
  'New',
  'HR Approved',
  'Interview',
  'Offer',
  'Hired',
];

export const isActiveCandidateStage = (stage: CandidateStage) =>
  ACTIVE_CANDIDATE_STAGES.includes(stage);

/**
 * Candidates screen URL showing a JD's active candidates, so it lists the same people as the
 * JD's applicant count and applicants modal. CandidateList reads `jdId` and `stage` on load.
 */
export const buildActiveCandidatesUrl = (jdId: string) => {
  const params = new URLSearchParams({ jdId });
  ACTIVE_CANDIDATE_STAGES.forEach((stage) => params.append('stage', stage));
  return `/candidates?${params.toString()}`;
};
